import React from 'react'
import { Button } from "reactstrap";

const Renderprofile= ({list,handleOnselected,lastBookElementRef}) => {
    return ( 

        <div className="row m-2">
        <div className="col">
          {list.length > 0 && (
            <table className="table table-hover table-responsive">
              <thead>
                <tr>
                  <th scope="col">no</th>
                  <th scope="col" className="d-none d-sm-block" >รหัสลูกค้า</th>
                  <th scope="col">ชื่อลูกค้า</th>
                  
                  <th scope="col">เลือก</th>
                </tr>
              </thead>
              <tbody>
                  
              {list &&
              list.map((item, index) => {
                if (list.length === index + 1) {
                  return (
                  <tr ref={lastBookElementRef} key={item._id}>
                    <td >{(item.no)}</td>
                    <td className="d-none d-sm-block">
                      <span className="text-info">
                        {(item.id)}
                      </span>
                    </td>
                    <td>
                      <div className="form-group">
                        <div className="col-sm">
                          <div className="row">
                           
                          {item.name} 
                          </div>
                       
                     
                        </div>
                      </div>
                    </td>
                    {/* <td  className="d-none d-sm-block">
                      <div className="form-group">
                        <div className="col-sm">
                          <div className="row">{item.telephone}</div>
                          <div className="row">
                            
                          </div>
                        </div>
                      </div>
                    </td> */}
                    <td>
                    <button
                      name={item._id}
                      type="button" 
                      className="btn btn-primary"
                      onClick={handleOnselected}
                    >
                      select
                    </button>
                    </td>
                  </tr>
              );
            } else {
              return (

                <tr key={item._id}>
                <td >{(item.no)}</td>
                <td className="d-none d-sm-block">
                  <span className="text-info">
                    {item.id}
                  </span>
                </td>
                <td>
                  <div className="form-group">
                    <div className="col-sm">
                      <div className="row">                      
                        {item.name} 
                      </div>                              
                    </div>
                  </div>
                </td>
                {/* <td  className="d-none d-sm-block">
                  <div className="form-group">
                    <div className="col-sm">
                      <div className="row">{item.telephone}</div>
                      <div className="row">                       
                      </div>
                    </div>
                  </div>
                </td> */}
                <td>
                <button
                  name={item._id}
                  type="button" 
                  className="btn btn-primary"
                  onClick={handleOnselected}
                >
                  select
                </button>
                </td>
              </tr>

              );
            }
        })}

              </tbody>
            </table>
          )}
        </div>
      </div>
     );
}
 
export default Renderprofile;